/**
 * Google Identity Services: bottone e callback con l'ID token. Lo script e'
 * caricato da index.html; qui si attende solo che window.google sia pronto,
 * senza rifare l'iniezione dello script.
 */

interface GoogleCredentialResponse {
  credential: string;
}

interface GoogleAccountsId {
  initialize(config: {
    client_id: string;
    callback: (response: GoogleCredentialResponse) => void;
  }): void;
  renderButton(
    parent: HTMLElement,
    options: { theme?: string; size?: string; width?: number | string },
  ): void;
}

declare global {
  interface Window {
    google?: { accounts: { id: GoogleAccountsId } };
  }
}

const READY_POLL_MS = 50;
const READY_TIMEOUT_MS = 5000;

function waitForGoogleIdentity(): Promise<GoogleAccountsId | null> {
  return new Promise((resolve) => {
    const start = Date.now();
    const check = () => {
      const accounts = window.google?.accounts.id;
      if (accounts) {
        resolve(accounts);
        return;
      }
      if (Date.now() - start > READY_TIMEOUT_MS) {
        resolve(null);
        return;
      }
      setTimeout(check, READY_POLL_MS);
    };
    check();
  });
}

/**
 * Non fa nulla (nessun bottone, nessun errore) se il client id non e'
 * configurato o Google non risponde entro il timeout: l'accesso con
 * email/password resta comunque disponibile.
 */
export async function renderGoogleButton(
  container: HTMLElement,
  onCredential: (credential: string) => void,
): Promise<void> {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  if (!clientId) return;

  const accounts = await waitForGoogleIdentity();
  if (!accounts) return;

  accounts.initialize({
    client_id: clientId,
    callback: (response) => onCredential(response.credential),
  });
  // renderButton APPENDE nel container invece di sostituirne il contenuto:
  // senza questa pulizia, il doppio effetto di React StrictMode in sviluppo
  // (useEffect invocato due volte) produce due bottoni impilati.
  container.replaceChildren();
  accounts.renderButton(container, { theme: 'outline', size: 'large', width: 320 });
}
